/**
 * HS classifier helpers (docs/decisions/hs-duty-tax.md part 2). Labels are
 * i18n keys under `trade:`; codes and descriptions come from the HS table.
 */
export const HS_DEPTHS = ["chapter", "heading", "subheading", "national"] as const;
export type HsDepth = (typeof HS_DEPTHS)[number];

export const hsDepthKey = (d: string | null | undefined): HsDepth =>
  (HS_DEPTHS as readonly string[]).includes(d ?? "") ? (d as HsDepth) : "chapter";

export const HS_REASONS = ["too_vague", "no_match", "table_not_loaded", "unknown"] as const;
export type HsReason = (typeof HS_REASONS)[number];
export const hsReasonKey = (r: string | null | undefined): HsReason =>
  (HS_REASONS as readonly string[]).includes(r ?? "") ? (r as HsReason) : "unknown";

export const VOTERS = ["lexical", "semantic", "precedent", "llm"] as const;
export type Voter = (typeof VOTERS)[number];
export const isKnownVoter = (v: string): v is Voter => (VOTERS as readonly string[]).includes(v);

/** Digits only — what the backend compares (`1704.90` → `170490`). */
export const normaliseHsCode = (code: string): string => code.replace(/[\s.-]/g, "");
